export default "__VITE_ASSET__C1$b_WvZ__"